const generateVariantArrayFromTabs = (tabsArr) => {
  const variantArr = tabsArr.map((el) => el.tab_vairant);

  return variantArr;
};

export default generateVariantArrayFromTabs;
